/**
 * Setor ativo (o "tenant" em que o usuário está operando) persistido em
 * localStorage. Mora aqui, e não no `UserSectorProvider`, porque o interceptor do
 * axios precisa ler o valor fora do React (ver `core/api/axios/index.ts`) —
 * importar o provider de lá arrastaria React pra dentro da camada de HTTP.
 *
 * Contrato (SA-1277): TODA escrita do setor ativo passa por `writeActiveSectorId`.
 * O backend autoriza chat/campanha comparando o setor do recurso com este valor,
 * então um setor em memória que não esteja aqui vira 403 nessas rotas.
 *
 * Por aba (SA-1483): o valor que vale é o do `sessionStorage`, que o navegador
 * isola por aba e mantém no F5; o `localStorage` só dá o ponto de partida de
 * uma aba nova. Sem isso, entrar numa conta por uma aba (a central abre a
 * conta do cliente em outra) trocava o header das requests de todas as abas,
 * e a aba de antes passava a mandar o setor do cliente.
 */
export const ACTIVE_SECTOR_LS_KEY = "superagents.activeSectorId.v1";

/** Header em que a request declara o setor ativo (ver `verify-sector-access.ts`). */
export const ACTIVE_SECTOR_HEADER = "x-active-sector";

const readFrom = (storage: () => Storage): string | null => {
  try {
    return storage().getItem(ACTIVE_SECTOR_LS_KEY);
  } catch {
    return null;
  }
};

const writeTo = (storage: () => Storage, id: string): void => {
  try {
    storage().setItem(ACTIVE_SECTOR_LS_KEY, id);
  } catch {
    /* storage indisponível */
  }
};

export function readActiveSectorId(): string | null {
  return readFrom(() => sessionStorage) ?? readFrom(() => localStorage);
}

export function writeActiveSectorId(id: string): void {
  writeTo(() => sessionStorage, id);
  writeTo(() => localStorage, id);
}
